module.exports = __webpack_public_path__ + "img/c-title.80d9da00.png";